<template>
  <div>
    <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
      <v-system-bar height="30" color="#fff" class="px-0">
        <span></span>
        <v-spacer></v-spacer>
        <v-icon size="32" class="pt-5" @click="close">mdi-close</v-icon>
      </v-system-bar>
      <v-card-title>
        <h3>
          {{ $t("message.magic.addKm", { value: "default" }) }}
        </h3></v-card-title
      >
      <v-card-text>
        <v-form ref="kmForm" v-model="valid" lazy-validation>
          <v-alert dense text :type="type" v-show="show">{{ message }}</v-alert>
          <v-row class="mt-0">
            <v-col md="4" class="label-field ">
              {{ $t("message.magic.metername", { value: "default" }) }}:
            </v-col>
            <v-col>
              <v-radio-group
                v-model="meterdata.metername"
                row
                hide-details="auto"
                class="mt-0"
                dense
              >
                <v-radio
                  :label="$t('message.magic.hours', { value: 'default' })"
                  value="H0URS"
                  dense
                  hide-details="auto"
                ></v-radio>
                <v-radio
                  :label="$t('message.magic.meter', { value: 'default' })"
                  value="MILEAGE"
                  dense
                  hide-details="auto"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="4" class="label-field">
              {{ $t("message.infoloc.locomotive", { value: "default" }) }}:
            </v-col>
            <v-col>
              <v-select
                dense
                outlined
                required
                :rules="locoRules"
                hide-details="auto"
                v-model="meterdata.assetnum"
                @change="loadlastreading"
                :items="assets"
                item-value="asset"
                item-text="asset"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="4" class="label-field">
              {{ $t("message.magic.lastreading", { value: "default" }) }}:
            </v-col>
            <v-col>
              <v-text-field
                dense
                outlined
                hide-details="auto"
                required
                type="number"
                class="mt-0"
                readonly
                :value="lastreading"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="4" class="label-field">
              {{ $t("message.magic.date", { value: "default" }) }}:
            </v-col>
            <v-col>
              <v-text-field
                dense
                outlined
                hide-details="auto"
                type="datetime-local"
                required
                :rules="dateRules"
                v-model="meterdata.newreadingdate"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-0">
            <v-col md="4" class="label-field">
              {{ $t("message.magic.newKm", { value: "default" }) }}:
            </v-col>
            <v-col>
              <v-text-field
                dense
                outlined
                :rules="kmRules"
                hide-details="auto"
                required
                type="number"
                class="mt-0"
                v-model="meterdata.newreading"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mb-2  d-flex justify-end">
            <v-btn color="#CCD2D5" class="mr-2" @click="clearForm" dark>{{
              $t("message.button.cancel", { value: "default" })
            }}</v-btn>
            <v-btn color="#00475A" dark @click="save()">{{
              $t("message.button.submit", { value: "default" })
            }}</v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MaximoService from "../services/MaximoService";
import { parseDatetimelocal } from "../shared/DateHelper";

export default {
  props: ["assets", "user"],
  data() {
    return {
      valid: true,
      type: "info",
      message: "",
      show: false,
      locoRules: [(v) => !!v || "Locomotive is required"],
      dateRules: [(v) => !!v || "Date is required"],
      kmRules: [(v) => !!v || "Km is required"],
      lastreading: null,
      meterdata: {
        assetnum: "",
        newreadingdate: new Date(),
        newreading: 0,
        siteid: "AKM",
      },
    };
  },
  methods: {
    save() {
      if (this.$refs.kmForm.validate()) {
        this.meterdata.newreadingdate = parseDatetimelocal(
          this.meterdata.newreadingdate
        );
        MaximoService.saveMeterdata(this.meterdata)
          .then(() => {
            this.message = this.$t("message.magic.success", {
              value: "default",
            });
            this.type = "success";
            this.show = true;
            this.$refs.kmForm.reset();
          })
          .catch(() => {
            this.message = this.$t("message.magic.error", { value: "default" });
            this.type = "error";
            this.show = true;
          });
      }
    },

    close() {
      this.$emit("kmClose", "");
      this.clearForm();
    },

    clearForm() {
      this.$refs.kmForm.reset();
    },

    loadlastreading(value) {
      if (this.meterdata.metername == "MILEAGE") {
        MaximoService.getLastMeter(value, "MILEAGE").then((response) => {
          this.lastreading = response.data.reading;
        });
      } else {
        MaximoService.getLastMeter(value, "H0URS").then((response) => {
          this.lastreading = response.data.reading;
        });
      }
    },
  },
  name: "PortalKm",
};
</script>

<style scoped>
.label-field {
  color: #00475a;
  font: normal normal bold 16px/19px Calibri;
  vertical-align: middle;
}
</style>
